/**
 * Utility functions for formatting strategy names and data
 * Migrated from multi-strategy-signals.html
 */

export function formatStrategyName(strategyType, configuration) {
  if (!strategyType) return 'Unknown';

  // Parse configuration if it's a string
  let config = {};
  if (typeof configuration === 'string') {
    try {
      config = JSON.parse(configuration);
    } catch (e) {
      config = {};
    }
  } else {
    config = configuration || {};
  }

  // Professional Momentum
  if (strategyType.includes('professional_momentum')) {
    const variant = config.variant_name || '';
    return variant ? `Pro Momentum ${variant}` : 'Pro Momentum';
  }

  // LRO strategies
  if (strategyType.includes('lro')) {
    const threshold = config.threshold || config.buy_threshold || 1.0;

    if (strategyType.includes('diamond')) {
      const variant = config.variant_name || '';
      return variant ? `Diamond LRO ${variant}` : `Diamond LRO ${threshold}`;
    }

    if (strategyType.includes('symmetric')) {
      return `LRO ${threshold}`;
    }

    return `LRO ${threshold}`;
  }

  // WaveTrend strategies - ORDER MATTERS (most specific patterns first)
  if (strategyType.includes('wavetrend')) {
    // Check for specific variants (order by specificity)
    // New renamed strategies
    if (strategyType.includes('bullish_cross_overbought_exit')) return 'WT Bullish→OB Exit';
    if (strategyType.includes('bullish_cross_negative_zone')) return 'WT Bullish→Neg Zone';
    if (strategyType.includes('bullish_cross_bearish_cross')) return 'WT Bullish→Bearish';
    // Refined strategies
    if (strategyType.includes('recovery_cross_cross_after_overbought')) return 'WT Recovery→OB Exit';
    if (strategyType.includes('recovery_cross_cross_above_zero')) return 'WT Recovery→Pos Zone';
    if (strategyType.includes('cross_after_oversold_cross_after_overbought')) return 'WT OS→OB';
    if (strategyType.includes('cross_after_oversold_cross_above_zero')) return 'WT OS→Pos Zone';
    // Legacy patterns (archived)
    if (strategyType.includes('bullish_cross_neg_either_extreme') ||
        strategyType.includes('bullish_cross')) return 'WT Bullish Cross';
    if (strategyType.includes('oversold_cross')) return 'WT Oversold Cross';
    if (strategyType.includes('oversold_zero')) return 'WT Oversold Zero';
    if (strategyType.includes('zero_cross')) return 'WT Zero Cross';
    return 'WaveTrend';
  }

  // Default
  return strategyType.replace(/_/g, ' ').replace(/\w/g, l => l.toUpperCase());
}

export function formatNumber(num, decimals = 2) {
  if (num === null || num === undefined) return '—';
  return Number(num).toFixed(decimals);
}

export function formatPercent(num, decimals = 1) {
  if (num === null || num === undefined) return '—';
  return `${Number(num).toFixed(decimals)}%`;
}

export function formatCurrency(num, decimals = 2) {
  if (num === null || num === undefined) return '—';
  return `$${Number(num).toFixed(decimals)}`;
}

export function formatDate(dateStr) {
  if (!dateStr) return '—';
  const date = new Date(dateStr);
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

export function categorizeStrategy(strategyType) {
  if (!strategyType) return 'Other';

  if (strategyType.includes('wavetrend')) return 'WaveTrend';
  if (strategyType.includes('lro_diamond')) return 'Diamond LRO';
  if (strategyType.includes('lro_symmetric')) return 'Symmetric LRO';
  if (strategyType.includes('professional_momentum')) return 'Professional Momentum';

  return 'Other';
}

export function calculateDaysHeld(signal) {
  if (!signal || !signal.date) return 0;
  const signalDate = new Date(signal.date);
  const today = new Date();
  const diffMs = today - signalDate;
  return Math.floor(diffMs / (1000 * 60 * 60 * 24));
}
